module.exports = __webpack_public_path__ + "img/kuala lumpur.ce3ede4d.png";